import { render, staticRenderFns } from "./ProjectUnitDetails.vue?vue&type=template&id=e51a463e"
import script from "../js/pudScript.js?vue&type=script&lang=js&external"
export * from "../js/pudScript.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports